import { Component, Input } from '@angular/core'
import { ServiceContract } from '@ui/Services/ServiceContract'
import HttpError from '@ui/HttpError'
import { InputValue } from '@ui/Components/Form/TextInput/TextInput.Component'
import Filterable from '@ui/Filterable'
import { DebouncedTextFilterComponent } from '@ui/Components/Filters/DebouncedTextFilter.Component'
import { NgStyle } from '@angular/common'
import { SlideToggleComponent } from '@ui/Components/Form/SlideToggle/SlideToggle.Component'
import {
	SelectComponent,
	SelectItem,
	SelectValue,
} from '@ui/Components/Form/Select/Select.Component'

export interface ListFilter<T extends Filterable> {
	type: 'text' | 'datetime' | 'toggle' | 'select'
	placeholder?: string
	value: InputValue | SelectValue
	service: ServiceContract<T>
	userHasAccess: boolean
	icon?: string
	selectItems?: SelectItem[]
	filter(value: InputValue): Promise<void>
}

@Component({
	selector: 'list-filter',
	templateUrl: './ListFilter.Component.html',
	imports: [
		DebouncedTextFilterComponent,
		NgStyle,
		SlideToggleComponent,
		SelectComponent,
	],
})
export class ListFilterComponent {
	@Input() public filter: ListFilter<any>

	public handleChange = async (value: InputValue | boolean): Promise<void> => {
		try {
			await this.filter.filter(value)
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
